
const win = window;
const VideoComponent = require('../../viscomjs/video/VideoComponent');
const SizesUtils = require('../../viscomjs/utils/SizesUtils');
const EventEmitter = require('eventemitter3');
const videoBg = require('./videoBg');
let videoListenersInited = false;
const evEmit = new EventEmitter();

const videoCover = new VideoComponent('videocover', {
    name: 'cover',
    selector: '.video-bg',
    container: '.video-bg__container--cover',
    poster: './img/poster-cover.jpg',
    src: [
        {src: './video/cover.mp4', type: 'video/mp4'},
        {src: './video/cover.webm', type: 'video/webm'}
    ],
    defaultMuted: true,
    playsinline: true,
    loop: true,
    size: 'cover'
});

const videoCoverOut = new VideoComponent('videocoverout', {
    name: 'coverout',
    selector: '.video-bg',
    container: '.video-bg__container--cover-out',
    poster: './img/poster-cover-out.jpg',
    src: [
        {src: './video/cover-out.mp4', type: 'video/mp4'},
        {src: './video/cover-out.webm', type: 'video/webm'}
    ],
    defaultMuted: true,
    playsinline: true,
    loop: false,
    size: 'cover'
});

const resizeVideos = () => {
    videoCover.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    videoCoverOut.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
}

const _addVideoResizeListeners = () => {
    if (videoListenersInited) return;
    videoListenersInited = true;
    win.addEventListener('resize', resizeVideos);
}

const removeVideoResizeListeners = () => {
    win.removeEventListener('resize', resizeVideos);
}

const _cleanVideos = () => {
    videoBg.start();
    removeVideoResizeListeners();
    videoCoverOut._video.removeEventListener('ended', _cleanVideos);
    videoCover.destroy();
    document.querySelector(videoCoverOut._containerSelector).classList.add('hide');
    setTimeout(() => {
        videoCoverOut.destroy();
    }, 1000);
    _sendCoverEndEvent();
}

const _sendCoverEndEvent = () => {
    evEmit.emit('coverEnded');
}

module.exports.startcover = () => {
    document.querySelector(videoCover._containerSelector).classList.add('show');
    videoCover.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    _addVideoResizeListeners();
    videoCover.start();
    videoCover._video.addEventListener('ended', _sendCoverEndEvent);
};

module.exports.startcoverout = () => {
    document.querySelector(videoCoverOut._containerSelector).classList.add('show');
    setTimeout(() => {
        document.querySelector(videoCover._containerSelector).classList.remove('show');
    }, 500);
    videoCover.stop();
    videoCoverOut.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    _addVideoResizeListeners();
    videoCoverOut.start();
    videoCoverOut._video.addEventListener('ended', _cleanVideos);
};

exports.evEmit = evEmit;

/*
module.exports.start = () => {
    video.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    win.addEventListener('resize', () => {
        video.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    });
    video.start();
}
*/


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/coverVideoBg.js